module.exports = __webpack_public_path__ + "img/Flexline Toolbar Logo(400 x 100 px).f4e13d58.png";